import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import _ from 'lodash'

import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
export default class NameArea extends Component {
    static propTypes = {
        activeGroup: IPropTypes.map.isRequired,
        changeGroupName: PropTypes.func.isRequired,
        edited: PropTypes.bool.isRequired,
        groupStackChangeNameBeingEdited: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props)
        const { activeGroup } = props
        this.state = {
            groupName: activeGroup.get('name'),
        }
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { activeGroup: nextActiveGroup } = nextProps
        const { activeGroup } = this.props

        // TODO: Rewrite, can't move this componentDidUpdate since it's advised not to use setState in componentDidUpdate
        // Possibly change the component so that groupName in state is prop
        if (nextActiveGroup && activeGroup && !nextActiveGroup.equals(activeGroup)) {
            this.setState({ groupName: nextActiveGroup.get('name') })
        }
    }

    componentDidUpdate(prevProps) {
        const { edited: previousEdited } = prevProps
        const { groupName } = this.state
        const { edited } = this.props
        const length = (groupName && groupName.length) || 0

        if (!previousEdited && edited) {
            this._textInput.focus()
            this._textInput.setSelectionRange(0, length)
        }
    }

    handleOnChange = (_e) => {
        this.setState({ groupName: _e.target.value })
    }

    handleUpdateGroupName = () => {
        const { changeGroupName, activeGroup, groupStackChangeNameBeingEdited } = this.props
        const { groupName } = this.state

        if (!_.isEmpty(groupName) && groupName !== activeGroup.get('name')) {
            changeGroupName(groupName, activeGroup.get('id'))
            groupStackChangeNameBeingEdited(false)
        } else {
            groupStackChangeNameBeingEdited(false)
            this.setState({ groupName: activeGroup.get('name') })
        }
    }

    handleOnBlur = () => this.handleUpdateGroupName()

    handleOnClick = () => {
        const { groupStackChangeNameBeingEdited } = this.props

        groupStackChangeNameBeingEdited(true)
    }

    handleOnKeyDown = (_e) => {
        const { groupStackChangeNameBeingEdited } = this.props

        switch (_e.keyCode) {
            case 13: {
                this.handleUpdateGroupName()
                break
            }
            case 27: {
                const { activeGroup } = this.props

                groupStackChangeNameBeingEdited(false)
                this.setState({ groupName: activeGroup.get('name') })
                break
            }
            default:
                break
        }
    }

    render() {
        const {
            state: { groupName },
        } = this
        const { edited } = this.props

        return (
            <div className={'group-stack-header-name-area'}>
                {edited ? (
                    <div className="input-wrap">
                        <input
                            type="text"
                            className="group-name-input"
                            onChange={this.handleOnChange}
                            onKeyDown={this.handleOnKeyDown}
                            value={groupName}
                            onBlur={this.handleOnBlur}
                            ref={(r) => (this._textInput = r)}
                        />
                    </div>
                ) : (
                    <div className="group-name-inactive" onClick={this.handleOnClick}>
                        <div className={'name'}>{groupName}</div>
                        <div className={'icon'} />
                    </div>
                )}
            </div>
        )
    }
}
